<template>
  <div class="password-input">
    <text-input
      :auto-focus="autoFocus"
      :value="value"
      placeholder="A strong password"
      :label="label"
      name="password"
      :type="showPassword ? 'text' : 'password'"
      :error="!isValidPassword"
      validation-message="A valid password is required"
      @input="$emit('input', $event)"
    />
    <div
      v-if="value"
      class="password-visibility"
      @click="showPassword = !showPassword"
    >
      <font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
    </div>
    <div class="password-criteria d-flex flex-wrap mb-4">
      <div v-for="criteria in passwordCriteria" :key="criteria.message">
        <span v-if="!criteria.isValid" class="criteria" />
        <span v-if="criteria.isValid" class="criteria valid">
          <font-awesome-icon v-if="criteria.isValid" icon="circle-check" />
        </span>
        <span>{{ criteria.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { TextInput } from '@inscribe/ui-kit';
import { isValidPassword, PASSWORD_CONDITIONS } from '../utils/validation';

export default {
  components: {
    'text-input': TextInput,
  },
  props: {
    ...TextInput.props,
    autoFocus: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Password',
    },
    value: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    isValidPassword() {
      return isValidPassword(this.value);
    },
    passwordCriteria() {
      return Object.keys(PASSWORD_CONDITIONS).map((key) => ({
        message: PASSWORD_CONDITIONS[key].message,
        isValid: PASSWORD_CONDITIONS[key].condition.test(this.value),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.password-input {
  position: relative;
  &.narrow {
    .password-criteria {
      max-width: 60%;
      @include respond-to('medium') {
        max-width: 100%;
      }
    }
  }
  .password-criteria {
    > div {
      color: $color-navy-blue-80;
      display: flex;
      font-size: $font-size-secondary;
      margin: 2px 0;
      width: 46%;
    }
    .criteria {
      &.valid {
        font-size: $font-size-default;
        height: 16px;
        margin-right: 8px;
        margin-top: 1px;

        svg {
          color: $color-navy-blue;
        }
      }

      &:not(.valid) {
        border: 2px solid $color-navy-blue-60;
        border-radius: 50%;
        display: flex;
        flex-shrink: 0;
        height: 16px;
        margin-right: 8px;
        margin-top: 3px;
        width: 16px;
      }
    }
  }

  .password-visibility {
    position: absolute;
    right: 16px;
    top: 36px;
    color: $color-navy-blue-40;

    &:hover {
      color: $color-navy-blue-80;
    }
  }
}
</style>
